/**
 * @public
 */
export type CssTimeUnit = 's' | 'ms';

/**
 * @public
 */
export type CssTime = `${string}${CssTimeUnit}` | number | 0;

/**
 * @public
 */
export namespace CssTime {

    /**
     * @public
     */
    export function isCssTime(value: unknown): value is CssTime {
        if (typeof value === 'number' || value === 0) {
            return true;
        }

        if (typeof value !== 'string') {
            return false;
        }

        if (value.trim() === '') {
            return false;
        }

        const timeRegex = /^-?\d+(\.\d+)?(s|ms)/;

        return timeRegex.test(value);
    }

}
